import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ConfigurationParameterResponse } from "../interfaces/configuration-parameters";
import { IpAuthService } from "./ip-auth.service";
import IpErrorResponse from "../interfaces/ip-error-response";
import { IpSnackbarService } from "./ip-snackbar.service";

@Injectable({
  providedIn: 'root',
})
export class IpConfigurationParametersService {
  private api = environment.api;
  private endpoint = `${this.api}/invopay/configuration-parameters`;

  private parametersSubject: BehaviorSubject<ConfigurationParameterResponse[] | null> =
      new BehaviorSubject<ConfigurationParameterResponse[] | null>(null);
    public parameters$: Observable<ConfigurationParameterResponse[] | null> =
      this.parametersSubject.asObservable();

  constructor(
    private http: HttpClient,
    private ipAuthService: IpAuthService,
    private ipSnackbarService: IpSnackbarService,
  ) { 
    this.ipAuthService.currentSession$.subscribe(session => {
      if (session) {
        this.loadConfigurationParameters();
      }
      else {
        this.parametersSubject.next(null);
      }
    });
  }


  getConfigurationParameters(): Observable<ConfigurationParameterResponse[]> {
    return this.http.get<ConfigurationParameterResponse[]>(this.endpoint);
  }
  
  getConfigurationParametersFront(): Observable<ConfigurationParameterResponse[]> {
    return this.http.get<ConfigurationParameterResponse[]>(this.endpoint + '/front');
  }

  updateConfigurationParameters(parameters: ConfigurationParameterResponse[]): Observable<any> {
    var body = { parameters };
    return this.http.put<any>(this.endpoint + '/all', body);
  }

  loadConfigurationParameters() {
    if (this.parametersSubject.getValue() !== null) {
      return;
    }
    this.getConfigurationParametersFront().subscribe({
      next: parameters => {
        this.parametersSubject.next(parameters);
      },
      error: (e: IpErrorResponse) => {
        this.ipSnackbarService.showErrorMessage(e);
      }
    });
  }
}